
  import { Component, OnInit, HostListener } from '@angular/core';
  import { ReportService } from '../services/report.service';
  import * as Highcharts from 'highcharts';
  import { ActivatedRoute, Router } from '@angular/router';

  import HPie from 'highcharts/modules/variable-pie';
  import { CustomLoaderService } from 'src/app/services/custom-loader.service';
  import { EncrdecrService } from 'src/app/Auth/encrdecr.service';
  import { isNullOrUndefined } from 'src/app/validation';
  import { ProfileService } from 'src/app/services/profile.service';
  import * as html2pdf from 'html2pdf.js'
  import { LoginService } from 'src/app/services/login.service';
import { LocalStoargeService } from '../services/local-stoarge.service';
  HPie(Highcharts);

  declare var $: any;
  declare var require: any;
  declare var $: any;

  @Component({
    selector: 'app-investmentsummaryreportscheduler',
    templateUrl: './investmentsummaryreportscheduler.component.html',
    styleUrls: ['./investmentsummaryreportscheduler.component.scss']
  })
  export class InvestmentsummaryreportschedulerComponent {
    today: Date = new Date();
    IsMobile: boolean = false;
    Highcharts = Highcharts;
    chart: Highcharts.Chart;
    tblSummary: any = []
    tblAssetWise: any = [];

    DashboardUserId: string = '';
    DashboardUserType: string = '';
    isMultiSelect: boolean = false;
    G_ClientBasicInfoId: any;
    G_UserType: number;
    G_UserId: string = '';
    G_UserID: string = '';   //Added by Saddam
    G_SubbrokerCode: string = '';
    SBId: string = '';
    EmpId: string = '';
    EmpCode: string = '';
    G_ROLEID: string = '0';
    DDLFilterType: string = 'R';    //Added by Saddam
    FilteredUserType: string = '3';
    FilteredUserId: string = '';

    ShowInvestSummReport: Boolean = false
    ShowMututalFundReport: Boolean = false
    ShowFDReportReport: Boolean = false
    ShowAIFReport: Boolean = false
    ShowPMSReport: Boolean = false

    // Summary Data
    InsecptionDATE: any = "";
    TotalvalueatCost: any = "";
    TotalMFvalueatCost: any = "";
    MFPortfoliovalue: any = "";
    realisedGainOrLoss: any = "";
    UnrealisedGainOrLoss: any = "";
    MFEarnedDividend: any = "";
    MFXirr: any = "";
    sinceXIRR: any = "";
    FYXIRR: any = "";
    QTXIRR: any = "";
    oneyearXIRR: any = "";
    ReportName: string = '';
    ClientName: string = '';
    Address: string = '';
    Today: Date = new Date();
    SB_IFD_Name: string = '';
    RM_Name: string = '';
    // Pie chart points
    PieDataSrc: any = []
    totalMarketValue: any = 0
    // Portfolio Report
    PortfolioReport: any = []
    // FD Report
    ClientFDDetails: any = []
    // AIF Report
    ClientAIFDetails: any = []
    // PMS Report
    ClientPMSDetails: any = []
    // PDF Header and Footer
    PDFPrintPriview: boolean = false
    // PDF Button
    PDFButton: boolean = false;
    // PDF schedule
    PDFSchedule: boolean = true;
    // Identity
    CurrentID: string = ""
    // Generate PDF 
    PDFDataArray: [boolean, boolean, boolean, boolean, boolean]
    NoDataFound:boolean = true
    totalprofitgain:string = '0'
    totalCSSMobile:string = "";

    constructor(private reportservice: ReportService, private Loader: CustomLoaderService,
      private EncrdecrService: EncrdecrService, private router: Router, private route: ActivatedRoute,
      private clientProfileService: ProfileService, private LoginService: LoginService,
    private localstorageService:LocalStoargeService) {

    }
    @HostListener('window:resize', ['$event'])
    @HostListener('window:afterprint', ['$event'])
    // @HostListener("window:scrollend", ['$event'])
    onResize(event) {
      this.SetViewPort(event.target.innerWidth)
    }
    SetViewPort(w) {
      if (w <= 767) {
        this.IsMobile = true;
        this.totalCSSMobile = "font-size: 16.5px !important;"
      }
      else {
        this.IsMobile = false;
        this.totalCSSMobile = "font-size: 16.5px !important;"
      }
    }
    ngOnInit() {
      debugger
      this.PDFDataArray = [false, false, false, false, false]
      this.route.queryParams.subscribe(params => {
        // check the param
        if (params["Username"] && params["Password"] && params["Identity"]) {
          // login with Data
          let LoginJson = {
            Username: params["Username"],
            Password: params["Password"]
          }
          const DataBody = JSON.stringify(LoginJson);
          sessionStorage.setItem('Tgsh@#3734fjfskshh==', '173.212.234.56');
          let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
          this.LoginService.PostLogin_NSE_Info(DataBody, 3, IpAddress).then(
            (res1: any) => {
              debugger;
              let res = JSON.parse(this.EncrdecrService.getDecr(res1));
              if (res != "Invalid Username and Password" && res.TOKEN_ID != null) {
                localStorage.removeItem("base64String")
                sessionStorage.setItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF', this.EncrdecrService.setEncr("1"));
                sessionStorage.setItem('YKHkxDnoSoOe6PdTjKrqfm4z6', this.EncrdecrService.setEncr("19"));
                sessionStorage.setItem('`huR,8@RK9^??b4 -.hfs!!uR,XX', res.TOKEN_ID);
                sessionStorage.setItem('F44sGAGh2xwkpUL', res.LOGIN_ID); // Session_SubBrokerId
                sessionStorage.setItem('V4WGROuLLBE6t98', res.USER_NAME); // Session_UserName
                sessionStorage.setItem('V8hpPfITcxhEI9x', res.EMAIL_ID); // Session_UserEmail
                sessionStorage.setItem('3erT@Qr65TdXwq1', res.LOGIN_ID);//Added by Bhushan
                sessionStorage.setItem('Xe003SRRyYEoOC2', res.MOBILE); // Session_UserMobile
                sessionStorage.setItem('pOWgAF62qFXnZMn', ''); // RazorCustId
                sessionStorage.setItem('Hldq31TLYwRbLJ8', res.SubBrokerCode); // Session_SubBrokerCode
                sessionStorage.setItem('L2D3506kIHSk3E0', res.USER_TYPE); // Session_UserType
                sessionStorage.setItem('qAkZrQYLWNBSlki', res.LOGIN_ID); // Session_CBId
                sessionStorage.setItem('pi4ZU2P3M8JE4q7', ''); // Session_B64CompanyLogo
                sessionStorage.setItem('SBLoginBase64PP', res.SBLogoBase64); //IFD Logo : Added by Saddam
                sessionStorage.setItem('ksdhUEDH78$#OPL', res.UserIPAddress);  // Logged In User IP Address : Added by Saddam

                if (res.Family_ID !== null && res.Family_ID !== undefined && res.Family_ID !== 'null') {
                  sessionStorage.setItem('hn0bHyGhfpGtrPe', res.Family_ID);  // Session_Family_ID
                }
                let ut = res.USER_TYPE;
                if (ut != undefined && ut != null && ut != '') {
                  if (this.EncrdecrService.getDecr(ut) == '3') {
                    sessionStorage.setItem('m5JkoXISmYRAIuY', res.USER_ID); // Session_UserId
                    sessionStorage.setItem('UZT6qHaDZSz66kx', res.LOGIN_ID); // Session_ClientBasicInfoId
                    sessionStorage.setItem('N1QJHdOkO7Hz8QC', res.LOGIN_ID);
                    sessionStorage.setItem('ySxterqMDG7RY2qTpuzrfA', this.EncrdecrService.setEncr("1"));
                    sessionStorage.setItem('AqVk7klfa+b0nlVjO8Y90I=', res.RiskProfile); //Aggressive/Moderate etc
                    sessionStorage.setItem('aaIHl0pIiYe71gyyxC/5xA==', res.RiskProfileStatus);//Active or Expired
                    sessionStorage.setItem('LWHTWnSDkv4+qaQXsO6tHYU=', res.RiskProfileLevel); //risk Level of client
                    sessionStorage.setItem('6l0NqN5kkIZCaDvdzUfYVK8g=', res.RiskProfileInsertedDate)
                    this.SetViewPort(window.innerWidth);
                    let ut = sessionStorage.getItem('L2D3506kIHSk3E0');
                    if (ut != null && ut != undefined && ut != "") {
                      this.G_UserType = parseInt(this.EncrdecrService.getDecr(ut));
                    }
                    if (this.G_UserType == 1) {
                      this.G_ROLEID = this.EncrdecrService.getDecr(sessionStorage.getItem('5gE4QWzFXWKewRC'));
                    }
                    try {
                      debugger
                      let rr: any = sessionStorage.getItem('hgWUIy487$mJwue');
                      if (rr != undefined && rr != null) {
                        let data = this.EncrdecrService.getDecr(rr).split('#*#');
                        if (!isNullOrUndefined(data)) {
                          this.DashboardUserId = data[0];
                          this.DashboardUserType = data[1];
                          sessionStorage.setItem("hgWUIy487$mJwue", null);
                        }
                      }
                    } catch (error) {
                      console.error(error)
                    }
                    window.location.href = "/InvestmentsummaryreportschedulerComponent?PDFScheduler=true&ClientID=" + this.EncrdecrService.getDecr(res.LOGIN_ID) + "&Identity=" + params["Identity"];
                    window.addEventListener("afterprint", (event) => {
                      this.CloseWindow()
                    });
                  }
                  else {
                    window.close()
                  }
                }
                else {
                  window.close()
                }
              }
              else {
                window.close()
              }
              this.Loader.hide();
            },
            (err: any) => {
              window.close()
            }
          );
        }
        else {
          this.SetViewPort(window.innerWidth);
          let ut = sessionStorage.getItem('L2D3506kIHSk3E0');
          if (ut != null && ut != undefined && ut != "") {
            this.G_UserType = parseInt(this.EncrdecrService.getDecr(ut));
          }
          if (this.G_UserType == 1) {
            this.G_ROLEID = this.EncrdecrService.getDecr(sessionStorage.getItem('5gE4QWzFXWKewRC'));
          }
          try {
            debugger
            let rr: any = sessionStorage.getItem('hgWUIy487$mJwue');
            if (rr != undefined && rr != null) {
              let data = this.EncrdecrService.getDecr(rr).split('#*#');
              if (!isNullOrUndefined(data)) {
                this.DashboardUserId = data[0];
                this.DashboardUserType = data[1];
                sessionStorage.setItem("hgWUIy487$mJwue", null);
              }
            }
          } catch (error) {
            console.error(error)
          }
          window.addEventListener("afterprint", (event) => {
            this.CloseWindow()
          });
        }
        if (params["PDFScheduler"]) {
          this.PDFSchedule = params["PDFScheduler"]
          if (params["PDFScheduler"]) {
            this.G_ClientBasicInfoId = params["ClientID"]
            this.CurrentID = params["Identity"]
            this.FilteredUserType = '3';
            this.FilteredUserId = this.G_UserID ? this.G_UserID : this.G_ClientBasicInfoId;
            this.GetInvestSummary()
          }
        }
        else {
          this.PDFSchedule = false
        }
      })
    }
    ngAfterViewInit() {
      if (sessionStorage.getItem("HLIHOLK332") != undefined && sessionStorage.getItem("HLIHOLK332") != null) {
        let value = sessionStorage.getItem("HLIHOLK332")
        if (value == "FromReport") {
          $('.MainBg').addClass('collapsed_Menu');
        }
      }
    }

    calldatatable() {
      $("#dataTable_tally_sheet1").DataTable().clear().draw();
      $('#dataTable_tally_sheet1').DataTable().destroy();
      let css = this.totalCSSMobile
      localStorage.removeItem("MFPOINTS")
      localStorage.removeItem("LinkedDebenturesPOINTS")
      localStorage.removeItem("DebtPOINTS")
      let valofcost = 0
      let marketval = 0
      let weight = 0
      let unreal = 0
      let PieDataPoints = []
      let totalMarketValue = this.totalMarketValue
      localStorage.removeItem("PieDataPoints")
      $(document).ready(function () {
        var table: any = '';
        $.fn.dataTable.ext.errMode = 'none';
        debugger
        table = $('#dataTable_tally_sheet1').DataTable({
          searching: false,
          paging: false,
          info: false,
          order: [[6, 'asc']],
          "bAutoWidth": false,
          columnDefs: [
            { targets: [0], visible: false },
            { bSortable: false, aTargets: ['no-sort'] },
          ],
          rowGroup: {
            dataSrc: [0],
            endRender: function (rows, group) {
              debugger
              let str = "";
              for (let item = 0; item < rows.count(); item++) {
                if (Number(String(rows.data()[item][2]).replace(/,/g,""))) {
                  valofcost = valofcost + Number(String(rows.data()[item][2]).replace(/,/g,""))
                }
                if (Number(String(rows.data()[item][3]).replace(/,/g,""))) {
                  marketval = marketval + Number(String(rows.data()[item][3]).replace(/,/g,""))
                }
                if (Number(String(rows.data()[item][4]).replace(/,/g,""))) {
                  weight = weight + Number(String(rows.data()[item][4]).replace(/,/g,""))
                }
                if (Number(String(rows.data()[item][5]).replace(/,/g,""))) {
                  unreal = unreal + Number(String(rows.data()[item][5]).replace(/,/g,""))
                }
              }
              valofcost = Number(valofcost.toFixed(2))
              marketval = Number(marketval.toFixed(2))
              weight = Number(weight.toFixed(2))
              unreal = Number(unreal.toFixed(2))
              if (Number.isNaN(unreal)) {
                unreal = 0
              }
              if (Number.isNaN(marketval)) {
                marketval = 0
              }
              if (Number.isNaN(valofcost)) {
                valofcost = 0
              }
              if (Number.isNaN(weight)) {
                weight = 0
              }
              str = $('<tr class="">').append(`<td class="border border-0" style="${css}">Total ${group}</td>
                <td class="text-right border border-0" style="${css}">${valofcost == 0 ? '-' : valofcost.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                <td class="text-right border border-0" style="${css}">${marketval == 0 ? '-' : marketval.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                <td class="text-right border border-0" style="${css}">${weight == 0 ? '-' : weight}</td>
                <td class="text-right border border-0" style="${css}">${unreal == 0 ? '-' : unreal.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                `);
              valofcost = (valofcost / Number(totalMarketValue)) * 100
              PieDataPoints.push({ name: group, y: valofcost })
  
              if (PieDataPoints.length > 0) {
                localStorage.setItem("PieDataPoints", JSON.stringify(PieDataPoints))
              }
              valofcost = 0;
              marketval = 0;
              weight = 0;
              unreal = 0;
              return str
            }
          },
          footerCallback: function (tfoot, data, start, end, display) {
            let valofCostFooter = 0
            let MarketValueFooter = 0
            let WeigthageFooter = 0
            let UnrealishFooter = 0
            for (let index = 0; index < data.length; index++) {
              try {
                if (Number(String(data[index][2]).replace(/,/g,""))) {
                  valofCostFooter = valofCostFooter + Number(String(data[index][2]).replace(/,/g,""))
                }
              }
              catch (err) {
                console.error(err)
              }
              try {
                if (Number(String(data[index][3]).replace(/,/g,""))) {
                  MarketValueFooter = MarketValueFooter + Number(String(data[index][3]).replace(/,/g,""))
                }
              }
              catch (err) {
                console.error(err)
              }
              try {
                if (Number(String(data[index][4]).replace(/,/g,""))) {
                  WeigthageFooter = WeigthageFooter + Number(String(data[index][4]).replace(/,/g,""))
                }
              }
              catch (err) {
                console.error(err)
              }
              try {
                console.warn("UnrealishFooter -> ",String(data[index][5]).replace(/,/g,""))
                if (Number(String(data[index][5]).replace(/,/g,""))) {
                  UnrealishFooter = UnrealishFooter + Number(String(data[index][5]).replace(/,/g,""))
                }
              }
              catch (err) {
                console.error(err)
              }
            }
            valofCostFooter = Number(valofCostFooter.toFixed(2))
            MarketValueFooter = Number(MarketValueFooter.toFixed(2))
            WeigthageFooter = Number(WeigthageFooter.toFixed(2))
            UnrealishFooter = Number(UnrealishFooter.toFixed(2))
            $(tfoot).find('td').eq(0).html("Grand Total");
            $(tfoot).find('td').eq(1).html(valofCostFooter.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }));
            $(tfoot).find('td').eq(2).html(MarketValueFooter.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }));
            $(tfoot).find('td').eq(3).html(WeigthageFooter);
            $(tfoot).find('td').eq(4).html(UnrealishFooter.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }));
          }
        });
      })
      setTimeout(() => {
        let data = localStorage.getItem("PieDataPoints")
        this.PieDataSrc = JSON.parse(data)
        this.renderData()
      }, 500);
    }

    calldatatable1() {
      $("#dataTable_tally_sheet2").DataTable().clear().draw();
      $('#dataTable_tally_sheet2').DataTable().destroy();
      let css = this.totalCSSMobile
      $(document).ready(function () {
        var table1: any = ''
        table1 = $('#dataTable_tally_sheet2').DataTable({
          searching: false,
          paging: false,
          info: true,
          order: [[0, 'asc'], [1, 'asc']],
          columnDefs: [
            { targets: [0, 1], visible: false },
            { bSortable: false, aTargets: ['no-sort'] },
          ],
          rowGroup: {
            dataSrc: [0, 1],
            endRender: function (rows, group) {
              debugger
              let Units = ''
              let PurNav = ''
              let costvalue = 0
              let currentvalue = 0
              let dividend = 0
              let absreturn = 0
              let absreturnPer = 0
              let XIRR = 0
              let Txns = 0
              let length = 0
              let totrec = `<td class="border" style="${css}">Total ${group}</td>` // Define Total (group name) in <td>
  
              for (let item = 0; item < rows.count(); item++) {
                // Units = Units + Number(rows.data()[item][3])
                // PurNav = PurNav + Number(rows.data()[item][4])
                costvalue = costvalue + Number(String(rows.data()[item][5]).replace(/,/g,""))
                currentvalue = currentvalue + Number(String(rows.data()[item][7]).replace(/,/g,""))
                dividend = dividend + Number(String(rows.data()[item][8]).replace(/,/g,""))
                absreturn = absreturn + Number(String(rows.data()[item][9]).replace(/,/g,""))
                absreturnPer = absreturnPer + Number(String(rows.data()[item][10]).replace(/,/g,""))
                XIRR = XIRR + Number(String(rows.data()[item][11]).replace(/,/g,""))
                Txns = Txns + Number(String(rows.data()[item][13]).replace(/,/g,""))
              }
              length = rows.count();
              XIRR = Number(XIRR / length);
              // Units = Number(Units.toFixed(2))
              // PurNav = Number(PurNav.toFixed(2))
              costvalue = Number(costvalue.toFixed(2))
              currentvalue = Number(currentvalue.toFixed(2))
              dividend = Number(dividend.toFixed(2))
              XIRR = Number(XIRR.toFixed(2))
              absreturn = Number(absreturn.toFixed(2))
              absreturnPer = Number(absreturnPer.toFixed(2))
              Txns = Number(Txns.toFixed(2))
  
              totrec = totrec + `<td class="text-right" style="${css}">${Units}</td>`
              totrec = totrec + `<td class="text-right" style="${css}">${PurNav}</td>`
              totrec = totrec + `<td class="text-right" style="${css}">${costvalue.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>`
              totrec = totrec + `<td class="text-right" style="${css}">${""}</td>`
              totrec = totrec + `<td class="text-right" style="${css}">${currentvalue.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>`
              totrec = totrec + `<td class="text-right" style="${css}">${dividend.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>`
              totrec = totrec + `<td class="text-right" style="${css}">${absreturn.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>`
              totrec = totrec + `<td class="text-right" style="${css}">${absreturnPer}</td>`
              totrec = totrec + `<td class="text-right" style="${css}">${XIRR}</td>`
              totrec = totrec + `<td class="text-right" style="${css}">${""}</td>`
              totrec = totrec + `<td class="text-right" style="${css}">${Txns}</td>`
              let str = $('<tr class="">').append(totrec)
              return str
            }
          },
          footerCallback: function (tfoot, data, start, end, display) {
            console.warn("MF DATA:", data)
            let costvalue = 0
            let currentvalue = 0
            let dividend = 0
            let absreturn = 0
            let absreturnPer = 0
            let XIRR = 0
            let Txns = 0
            for (let index = 0; index < data.length; index++) {
              costvalue = costvalue + Number(String(data[index][5]).replace(/,/g,""))//Number(rows.data()[item][5])
              currentvalue = currentvalue + Number(String(data[index][7]).replace(/,/g,""))//Number(rows.data()[item][7])
              dividend = dividend + Number(String(data[index][8]).replace(/,/g,""))//Number(rows.data()[item][8])
              absreturn = absreturn + Number(String(data[index][9]).replace(/,/g,""))//Number(rows.data()[item][9])
              absreturnPer = absreturnPer + Number(String(data[index][10]).replace(/,/g,""))//Number(rows.data()[item][10])
              XIRR = XIRR + Number(String(data[index][11]).replace(/,/g,""))//Number(rows.data()[item][11])
              Txns = Txns + Number(String(data[index][13]).replace(/,/g,""))//Number(rows.data()[item][13])
            }
            // length = rows.count();
            // XIRR = Number(XIRR/length);
            costvalue = Number(costvalue.toFixed(2))
            currentvalue = Number(currentvalue.toFixed(2))
            dividend = Number(dividend.toFixed(2))
            // XIRR = Number(XIRR.toFixed(2))
            absreturn = Number(absreturn.toFixed(2))
            absreturnPer = Number(absreturnPer.toFixed(2))
            Txns = Number(Txns.toFixed(2))
  
            $(tfoot).find('td').eq(0).html("Grand Total");
            $(tfoot).find('td').eq(3).html(costvalue.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }));
            $(tfoot).find('td').eq(5).html(currentvalue.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }));
            $(tfoot).find('td').eq(6).html(dividend.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }));
            $(tfoot).find('td').eq(7).html(absreturn.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }));
            $(tfoot).find('td').eq(8).html(absreturnPer);
            // $(tfoot).find('td').eq(9).html(XIRR);
            $(tfoot).find('td').eq(11).html(Txns);
          }
        })
      })
    }

    calldatatablePMS() {
      $("#tblPMSHoldingReport").DataTable().clear().draw();
      $('#tblPMSHoldingReport').DataTable().destroy();
      $(document).ready(function () {
        var table: any = '';
        $.fn.dataTable.ext.errMode = 'none';
        debugger
        table = $('#tblPMSHoldingReport').DataTable({
          searching: false,
          paging: false,
          info: false,
          order: [[6, 'asc']],
          footerCallback: function (tfoot, data, start, end, display) {
            let AmountCurrent = 0
            let Currentvalue = 0
            let absgainloss = 0
            for (let index = 0; index < data.length; index++) {
              // Amount Current
              try {
                if (Number(String(data[index][2]).replace(/,/g,""))) {
                  AmountCurrent = AmountCurrent + Number(String(data[index][2]).replace(/,/g,""))
                }
              }
              catch (err) {
                console.error(err)
              }
              // Current Value
              try {
                if (Number(String(data[index][3]).replace(/,/g,""))) {
                  Currentvalue = Currentvalue + Number(String(data[index][3]).replace(/,/g,""))
                }
              }
              catch (err) {
                console.error(err)
              }
              // Absolute Gain and Loss
              try {
                if (Number(String(data[index][4]).replace(/,/g,""))) {
                  absgainloss = absgainloss + Number(String(data[index][4]).replace(/,/g,""))
                }
              }
              catch (err) {
                console.error(err)
              }
            }
            $(tfoot).find('td').eq(0).html("Grand Total");
            $(tfoot).find('td').eq(2).html(AmountCurrent.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }));
            $(tfoot).find('td').eq(3).html(Currentvalue.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }));
            $(tfoot).find('td').eq(4).html(absgainloss.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }));
          }
        })
      })
    }
  
    calldatatableFD() {
      $("#Fd_Mature_Datatable").DataTable().clear().draw();
      $('#Fd_Mature_Datatable').DataTable().destroy();
      $(document).ready(function () {
        var table: any = '';
        $.fn.dataTable.ext.errMode = 'none';
        debugger
        table = $('#Fd_Mature_Datatable').DataTable({
          searching: false,
          paging: false,
          info: false,
          footerCallback: function (tfoot, data, start, end, display) {
            let valueatcost = 0
            for (let index = 0; index < data.length; index++) {
              // Amount Current
              try {
                if (Number(String(data[index][6]).replace(/,/g,""))) {
                  valueatcost = valueatcost + Number(String(data[index][6]).replace(/,/g,""))
                }
              }
              catch (err) {
                console.error(err)
              }
            }
            $(tfoot).find('td').eq(0).html("Grand Total");
            $(tfoot).find('td').eq(6).html(valueatcost.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }));
          }
        })
      })
    }
    renderData() {
      let Options: any = {
        chart: {
          type: 'pie',
          width: 300,
          height: 450,
        },
        legend: {
          align: 'left',
          verticalAlign: 'bottom',
          x: -10,
          y: 20
        },
        credits: {
          enabled: false
        },
        title: {
          text: 'Asset Class Allocation(%)',
          align: 'center',
          style: {
            fontSize: '17px',
          }
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %'
            },
            showInLegend: true

          }
        },
        series: [{
          name: 'Brands',
          data: this.PieDataSrc
        }],
        colors: [
          '#ff9933',
          '#339966',
          '#4caefe',
          '#797a81',
          '#ff99cc'
        ],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 600
            },
            chartOptions: {
              chart: {
                spacing: [10, 0, 10, 0],
                margin: [0, 0, 0, 0]
              },
              plotOptions: {
                pie: {
                  dataLabels: {
                    distance: '15%',
                    format: '<b>{point.name}</b><br>{point.percentage:.1f} %'
                  }
                }
              }
            }
          }]
        }
      }
      Highcharts.chart('OverallProductChart', Options);
    }

    GetInvestSummary() {
      this.PDFButton = false;
      this.Loader.show()
      // setTimeout(() => {
      //   this.PDFButton = true;
      //   this.Loader.hide()
      // },5000)
      // InvestMent Summery Report
      let JSONData = {
        "ClientId": this.G_ClientBasicInfoId,
        "Usertype": 3,//this.DashboardUserType != "" ? this.DashboardUserType : this.FilteredUserType,
        "UserId": this.DashboardUserId != "" ? this.DashboardUserId : this.FilteredUserId,
      }
      this.reportservice.getInvestSummary(JSONData).subscribe((res) => {
        console.warn(res)
        this.GetMutualFundReport()
        if (res.ArrayOfResponse.length > 0) {
          this.tblSummary = res.ArrayOfResponse[0].summary
          this.tblAssetWise = res.ArrayOfResponse[0].Assetwise
          if (this.tblAssetWise) {
            this.totalMarketValue = 0
            for (const [key, value] of Object.entries(this.tblAssetWise)) {
              if (value["ValueAtCost"]) {
                this.totalMarketValue = this.totalMarketValue + Number(value["ValueAtCost"])
              }
            }
          }
          if (this.tblSummary.length > 0) {
            this.InsecptionDATE = this.tblSummary[0].InceptionDate
            this.TotalvalueatCost = this.ConvertToIndianRsWithoutDecimal(this.tblSummary[0].TotalValueAtCost)
            this.TotalMFvalueatCost = this.ConvertToIndianRsWithoutDecimal(this.tblSummary[0].TotalMFValueAtCost)
            this.MFPortfoliovalue = this.ConvertToIndianRsWithoutDecimal(this.tblSummary[0].MFPortfolioValue)
            this.UnrealisedGainOrLoss = this.ConvertToIndianRsWithoutDecimal(this.tblSummary[0].UnRealisedGainLoss)
            this.MFEarnedDividend = this.ConvertToIndianRsWithoutDecimal(this.tblSummary[0].MFEarnedDividend)
            this.realisedGainOrLoss = this.ConvertToIndianRsWithoutDecimal(this.tblSummary[0].RealisedGainLoss)
            this.MFXirr = this.tblSummary[0].MFXIRR
            this.FYXIRR = this.tblSummary[0].FYTDXIRR
            this.QTXIRR = this.tblSummary[0].QTDXIRR
            this.oneyearXIRR = this.tblSummary[0].oneyrxXIRR
            this.totalprofitgain = this.ConvertToIndianRsWithoutDecimal(Number(Number(this.tblSummary[0].RealisedGainLoss) + Number(this.tblSummary[0].MFEarnedDividend) + Number(this.tblSummary[0].UnRealisedGainLoss)))
            this.ShowInvestSummReport = true
          }
          else {
            this.ShowInvestSummReport = false
          }
          this.calldatatable();
        }
        else {
        }
      })
    }

    // Mutual Fund 
    GetMutualFundReport() {
      if (this.G_ClientBasicInfoId) {
        const d = new Date();
        let todayDate = `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`
        if (this.G_UserType == 2) {
          this.FilteredUserId = this.G_ClientBasicInfoId
        }
        let data = {
          "Clientid": this.G_ClientBasicInfoId,
          "UserId": this.DashboardUserId != "" ? this.DashboardUserId : this.FilteredUserId,
          "UserType": this.DashboardUserType != "" ? this.DashboardUserType : this.FilteredUserType,
          "ToDate": todayDate,
          "FolioType": "Active",
          "RoleID": this.G_ROLEID
        }
        this.reportservice.GetPortfolioComprehensiveReport(data).subscribe(data_res => {
          this.GetFDReport()
          if (data_res != null) {
            data_res = JSON.parse(this.EncrdecrService.getDecr(data_res));
            if (data_res.ArrayOfResponse) {
              if (data_res.ArrayOfResponse.length > 0) {
                if (data_res.ArrayOfResponse[0].sumsummary) {
                  this.PortfolioReport = data_res.ArrayOfResponse[0].sumsummary
                  this.ShowMututalFundReport = true
                  this.calldatatable1()
                }
                else {
                  this.PortfolioReport = []
                  this.ShowMututalFundReport = false
                }
              } else {
                this.PortfolioReport = []
                this.ShowMututalFundReport = false
              }
            }
          }
        })
      }
    }

    // FD Report
    GetFDReport() {
      let currentData = new Date()
      const Json = {
        "ClientBasicInfoIdList": `${this.G_ClientBasicInfoId}`,
        "EmployeeId": "0",
        "LoginMode": "emp",
        "Subbrokerid": "0",
        "RoleID": "",
        "FromDate": `${currentData.getDate()}/${currentData.getMonth() + 1}/${currentData.getFullYear()}`,
        "ToDate": "31/03/2099",
      }
      let json_str = JSON.stringify(Json);
      this.reportservice.GetClientFDBeforeMaturityReport(json_str).subscribe(
        (res1) => {
          this.GetAIFReport()
          // res1 = JSON.parse(this.EncrdecrService.getDecr(res1));
          // if (res1.ArrayOfResponse) {
          //   if (res1.ArrayOfResponse.length > 0) {
          //     this.ClientFDDetails = res1.ArrayOfResponse;
          //     this.ShowFDReportReport = true
          //     this.calldatatableFD()
          //   }
          //   else {
          //     this.ClientFDDetails = []
          //     this.ShowFDReportReport = false
          //   }
          // }
          // else {
          //   this.ClientFDDetails = []
          //   this.ShowFDReportReport = false
          // }
        }
      )
    }

    // AIF Report
    GetAIFReport() {
      let SB_EMP_ID = this.SBId == '' ? this.EmpId : this.SBId
      let LoginIdCode = SB_EMP_ID + '|' + "";
      this.reportservice.getAIFTransaction
        (
          'CLIENT_ID',
          this.G_UserType,
          LoginIdCode,
          this.G_ClientBasicInfoId,
          this.G_ROLEID.toString()
        ).subscribe(data_res => {
          this.GetPMSReport()
          let data = JSON.parse(this.EncrdecrService.getDecr(data_res));
          if (data) {
            if (
              data.Message != null &&
              data.Message != "" &&
              data.Message.indexOf("Not Authorized") > -1
            ) {
              this.Loader.hide();
            }
            else {
              if (data.ArrayOfResponse) {
                if (data.ArrayOfResponse.length > 0) {
                  this.ClientAIFDetails = data.ArrayOfResponse
                  this.ShowAIFReport = true
                }
                else {
                  this.ClientAIFDetails = []
                  this.ShowAIFReport = false
                }
              }
              else {
                this.ClientAIFDetails = []
                this.ShowAIFReport = false
              }
            }
          }
        })
    }

    // PMS Report
    GetPMSReport() {
      let SB_EMP_ID = this.SBId == '' ? this.EmpId : this.SBId
      let LoginIdCode = SB_EMP_ID + '|' + "";
      // PMS
      this.reportservice.getPMSHoldings
        (
          'CLIENT_ID',
          // this.G_UserType,
          this.G_UserType,
          (LoginIdCode),
          this.G_ClientBasicInfoId,
          this.G_ROLEID.toString()
        ).subscribe(data_res => {

          let data = JSON.parse(this.EncrdecrService.getDecr(data_res));
          if (data) {
            if (
              data.Message != null &&
              data.Message != "" &&
              data.Message.indexOf("Not Authorized") > -1
            ) {
              this.Loader.hide();
              return;
            }
            else {
              if (data.ArrayOfResponse) {
                if (data.ArrayOfResponse.length > 0) {
                  this.ClientPMSDetails = data.ArrayOfResponse;
                  this.ShowPMSReport = true
                  this.calldatatablePMS()
                }
                else {
                  this.ClientPMSDetails = []
                  this.ShowPMSReport = false
                }
              }
              else {
                this.ClientPMSDetails = []
                this.ShowPMSReport = false
              }
            }
          }
          if (this.PortfolioReport.length == 0 && this.ClientFDDetails.length == 0 && this.ClientAIFDetails.length == 0 && this.ClientPMSDetails == 0) {
            this.NoDataFound = false
          }
          else{
            this.NoDataFound = true
          }
          this.PDFButton = true;
          this.Loader.hide()
          this.ExportToPdf_summary()
        })
    }

    // Client Filter Data
    ClientFilterData(e) {
      this.G_ClientBasicInfoId = e.ClientBasicInfoId;
      debugger
      if (e.flag == 'employee') {
        this.EmpId = e.EmployeId;
      }
      else if (e.flag == 'SubBroker') {
        this.SBId = e.SubBrokerId;
      }
      else {
        this.G_ClientBasicInfoId = e.ClientBasicInfoId;
        switch (this.G_UserType) {
          case 1:
            if (this.SBId == '') {
              this.FilteredUserType = '1';
              this.FilteredUserId = this.EmpId == '' ? this.G_UserID : this.EmpId;
              if (!this.EmpId) {
                this.FilteredUserId = this.G_ClientBasicInfoId
                this.FilteredUserType = '3'
              }
              ;
            }
            else {
              this.FilteredUserType = '2';
              this.FilteredUserId = this.SBId;
            }
            break;
          case 2:
            this.FilteredUserType = '2';
            this.FilteredUserId = this.SBId == '' ? this.G_UserID : this.SBId; //this.SBId;
            break;
          case 3:
            this.FilteredUserType = '3';
            this.FilteredUserId = this.G_UserID ? this.G_UserID : this.G_ClientBasicInfoId;
            break;
        }
      }
    }

    CallAlertModal(msg: any) {
      $('#AlertModal').modal({ backdrop: 'static', keyboard: false });
      $('#AlertModalContent').text(msg);
    }

    CalculateAbsolutePer(cost, abs) {
      let res = "0"
      res = ((abs / cost) * 100).toFixed(2)
      return res
    }
    ConvertToIndianRsWithDecimal(IpAmount: any) {
      IpAmount = Number(IpAmount)
      return IpAmount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    ConvertToIndianRsWithoutDecimal(IpAmount: any) {
      IpAmount = Number(IpAmount)
      return IpAmount.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }
    ExportToPdf_summary() {
      let data: any = '';
      this.PDFPrintPriview = true
      this.Loader.show()
      this.BindClientHeaderData()
    }
    // Bind Close 
    CloseWindow() {
      sessionStorage.removeItem('pdfstring');
      sessionStorage.removeItem('sdkhlkj398');
      this.PDFPrintPriview = false
      location.reload();
    }

    // Bind Header and Footer
    BindClientHeaderData() {
      this.Today = new Date()
      this.ReportName = "Investment Summary Report"
      let req = {
      "ClientBasicInfoId": this.G_ClientBasicInfoId,
      "flag": "All"
      }
      this.clientProfileService.GetClientDetailsPDF(req).subscribe(
        (response: any) => {
          let res = JSON.parse(this.EncrdecrService.getDecr(response))
          if (res != null) {
            if (res.Message != null && res.Message != "" && res.Message.indexOf("Not Authorized") > -1) {
              this.Loader.hide();
              return;
            }
            else {
              let details = res.ArrayOfResponse;
              if (details.length > 0) {
                this.ClientName = details[0].clientname;
                this.Address = details[0].address;
                debugger
                let sb = details[0].SubbrokerDetails;
                if (sb.length != 0) {
                  if (sb.length > 1) {
                    debugger
                    this.SB_IFD_Name = 'Multiple';
                  }
                  else {
                    debugger
                    this.SB_IFD_Name = sb[0].subbrokername;
                  }
                }
                let rm = details[0].RMDetails;
                debugger
                if (rm.length != 0) {
                  if (rm.length > 1) {
                    debugger
                    this.RM_Name = 'Multiple';
                  }
                  else {
                    debugger
                    this.RM_Name = rm[0].rmname;
                  }
                }
                let base64String = ""
                setTimeout(() => {
                  var originalContents = document.body.innerHTML;
                  let pdfname = this.ReportName;
                  let time = new Date();
                  // document.title = `${pdfname}${time.getTime()}`;
                  // var printReport = document.getElementById('divpdfnotmob').innerHTML;
                  // document.body.innerHTML = printReport;
                  // window.print();
                  // setTimeout(()=>{
                  const element = document.getElementById('divpdfnotmob'); // Replace with your actual HTML element
                  const sumdiv = document.getElementById("divSummary") // summary Div
                  const mfdiv = document.getElementById("divMF") // MF Div
                  const fddiv = document.getElementById("divFD") // FD Div
                  const aifdiv = document.getElementById("divAIF") // AIF Div
                  const pmsdiv = document.getElementById("divPMS") // PMS Div
                  let pageHeight = 0
                  let pageWidth = 0
                  pageHeight = Math.max(sumdiv.clientHeight, mfdiv.clientHeight, fddiv.clientHeight, aifdiv.clientHeight, pmsdiv.clientHeight)
                  pageWidth = Math.max(sumdiv.clientWidth, mfdiv.clientWidth, fddiv.clientWidth, aifdiv.clientWidth, pmsdiv.clientWidth)
                  if (pageHeight > 1000) {
                    pageHeight = sumdiv.clientHeight
                  }
                  if(!this.NoDataFound){
                    pageHeight = 700
                  }
                  var opt = {
                    filename: this.ReportName,
                    image: { type: 'jpeg', quality: 5 },
                    html2canvas: { scale: 2, dpi: 192, },
                    jsPDF: { format: [980.43, 1298.27], unit: "pt", orientation: 'landscape' },
                    pagebreak: { before: '.newPage', after:['#divSummary',"#pdfHeaderFirstPage"] , avoid: ['tr','.disclaimer-box',".LastPage"], mode: [ 'css', 'legacy'] },
                    margin: [100, 0, 0, 0],
                    // 'autofit':
                    // {
                    //   'x': 'scale-to-fit'
                    // }
                  };
                  let checkpdfmode = false
                  checkpdfmode = this.PDFSchedule
                  let bse64
                  html2pdf().from(element).set(opt).toPdf().get('pdf').then((pdf) => {
                    var totalPages = pdf.internal.getNumberOfPages();
                    for (let i = 1; i <= totalPages; i++) {
                      // Set footer to every page
                      pdf.setPage(i);
                      // Set footer font
                      pdf.setFontSize(20);
                      pdf.setTextColor(0);
                      pdf.setFont('OpenSansRegular',"B"); // Set your desired font

                      const textWidth = pdf.internal.pageSize.getWidth(); // Get page width
                      const margin = 2; // Left and right margin
                      const marginAboveFooter = 5; // Margin above the footer
                      let asondate = new Date();
                      const leftContent = `Client Name: ${this.ClientName}      Report as on: ${asondate.getDate()}-${asondate.toLocaleString('default', { month: 'short' })}-${asondate.getFullYear()}`;
                      const rightContent = ``;
                      // Add footer text with calculated positions
                      // pdf.text(0, 0, leftContent, { align: 'left' });
                      // pdf.text(0, 0, rightContent, { align: 'right' });
                      if (i != 1) {
                        pdf.text(leftContent, 200, 40);
                        pdf.text(rightContent, pdf.internal.pageSize.getWidth() / 2, 40);
                        // pdf.addImage('https://optimumangularuat.jmfonline.in/assets/images/Logo_JM.png', 'PNG', pdf.internal.pageSize.getWidth()-300, 10, 230, 60);
                      }
                    }
                    const pdfOutput = pdf.output('datauristring').split(',')[1];
                    if (checkpdfmode) {
                      // localStorage.removeItem("base64String")
                      bse64 = pdfOutput
                      localStorage.setItem("base64String", "Yes")
                    }
                  })
                  // html2pdf().from(element).set(opt).outputPdf().then(function (pdf) {
                  //   // This logs the base64 string
                  //   if (checkpdfmode) {
                  //     // localStorage.removeItem("base64String")
                  //     bse64 = btoa(pdf)
                  //     localStorage.setItem("base64String", "Yes")
                  //   }
                  //   else {
                  //     let pdfdata = "data:application/pdf;base64, " + btoa(pdf)
                  //     //console.log(btoa(pdf))
                  //     let DATA = pdfdata;
                  //     const link = document.createElement("a")
                  //     link.href = DATA;
                  //     link.download = "Portfolio Report" + ".pdf"
                  //     link.click()
                  //     link.remove()
                  //     this.Loader.hide();
                  //   }
                  // });
                  if (this.PDFSchedule) {
                    let checkAPIcall = setInterval(() => {
                      base64String = localStorage.getItem("base64String")
                      if (base64String == "Yes") {
                        let JSON = {
                          ClientID: this.G_ClientBasicInfoId,
                          Base64string: bse64,
                          FileName: `${this.G_ClientBasicInfoId}_InvestMentSummaryReport.pdf`,
                          ID: this.CurrentID
                        }
                        console.clear()
                        console.warn("Scheduler Portfolio Request")
                        this.reportservice.SendPortFolioClient(JSON).subscribe((r) => {
                          if (r) {
                            console.warn("Scheduler Portfolio Response",r)
                            if (r.ArrayOfResponse) {
                              this.CallAlertModal("PDF Send successfully!")
                              if (r.ArrayOfResponse.length > 0) {
                                let username = r.ArrayOfResponse[0].PANNo
                                let password = r.ArrayOfResponse[0].password
                                let ID = r.ArrayOfResponse[0].IdentityID
                                localStorage.removeItem("base64String")
                                sessionStorage.clear();
                                // localStorage.clear();
                                this.localstorageService.ClearLocalStorageWithoutCleverTapKeys(); //Added by tishya
                                window.location.href = `/InvestmentsummaryreportschedulerComponent?Username=${username}&Password=${password}&Identity=${ID}`;
                              }
                              else {
                                sessionStorage.clear();
                                // localStorage.clear();
                                this.localstorageService.ClearLocalStorageWithoutCleverTapKeys(); //Added by tishya
                              }
                            }
                          }
                        })
                        clearInterval(checkAPIcall)
                      }
                      // localStorage.removeItem("base64String")
                    }, 500)
                  }
                  // },500)
                  // this.PDFPrintPriview=false
                  setTimeout(() => {
                    this.Loader.hide()
                    this.PDFPrintPriview = false
                  }, 1000)
                }, 500)
              }
            }
          }
        },
        err => {
          this.Loader.hide();
        });
    }
  }
